package com.essntl.uikit.components.card

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDateRange
import kotlinx.datetime.*

@Composable
fun WeekDateCard(
    date: LocalDate,
    onDateSelected: (LocalDate) -> Unit,
    datesRange: ArrayList<String>,
) {
    Column(
        verticalArrangement = Arrangement.SpaceBetween,
        modifier = Modifier
            .width(264.dp)
            .heightIn(min = 115.dp)
            .background(
                color = MaterialTheme.esColorScheme.tinted,
                shape = RoundedCornerShape(size = 2.spacing),
            )
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.borderPrimary,
                shape = RoundedCornerShape(size = 2.spacing),
            )
            .padding(1.5.spacing),
    ) {
        Column(
            verticalArrangement = Arrangement.spacedBy(5.dp),
            horizontalAlignment = Alignment.Start,
        ) {
            val datesText = listOf(
                datesRange.first(),
                datesRange.last(),
            ).formatDateRange()

            Text(
                text = datesText,
                style = MaterialTheme.esTypography.s2SemiBold16,
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            EsMediumOutlineIconButton(
                onClick = {
                    val previousMonday = date.minus(DatePeriod(days = 7))
                    onDateSelected(previousMonday)
                },
                iconRes = EsIcons.ArrowLeft,
            )

            EsMediumOutlineButton(
                onClick = {
                    onDateSelected(
                        Clock.System.now().toLocalDateTime(TimeZone.UTC).date.minus(
                            Clock.System.now().toLocalDateTime(TimeZone.UTC).date.dayOfWeek.ordinal.toLong(),
                            DateTimeUnit.DAY,
                        ),
                    )
                },
                text = "Current",
            )

            EsMediumOutlineIconButton(
                onClick = {
                    val nexTMonday = date.plus(DatePeriod(days = 7))
                    onDateSelected(nexTMonday)
                },
                iconRes = EsIcons.ArrowRight,
            )
        }
    }
}